module.exports = __webpack_public_path__ + "Icon_Giveaway Items.ae37e2b25ef9328c1cec.png";